import { HomeOutlined, PlusOutlined } from "@ant-design/icons";
import { Link, useParams } from "react-router-dom";
import { Card, Row } from "antd";

import translations from "../../translations";
import getTranslatedText from "../../helpers/getTranslatedText";
import BoycottTitle from "./Title";
import Meta from "antd/lib/card/Meta";
import boycottList from "./constants/companies_list";

const data = boycottList;

const Boycott = () => {
  const { lang } = useParams();

  return (
    <div>
      <center>
        <BoycottTitle />
        <p style={{ fontSize: "20px" }}>
          {getTranslatedText(translations, "boycottLabel", lang)}
        </p>
      </center>

      <Row justify="space-around">
        {data.map((item) => (
          <Card
            hoverable
            style={{
              width: 240,
              margin: "16px  5px",
            }}
            cover={<img alt={item.name} src={item.logo} />}
            id={item.id}
          >
            <Meta title={item.name} description={item.extraDetails} />
          </Card>
        ))}
      </Row>

      <a
        href="https://forms.gle/SU2z7jthU73QAxfP7"
        title="add"
        target="_blank"
        id="home-btn"
        style={{ bottom: 120 }}
        rel="noreferrer"
      >
        <PlusOutlined style={{ fontSize: "25px", color: "white" }} />
      </a>

      <Link to="/:" title="Home" id="home-btn">
        <HomeOutlined style={{ fontSize: "25px", color: "white" }} />
      </Link>
    </div>
  );
};

export default Boycott;
